import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { convertUtcDate } from '../components/Common/cleanDates';

import {
    REQUEST_INVENTORY_REPACKAGES,
    FETCH_INVENTORY_REPACKAGES_SUCCESS,
    FETCH_INVENTORY_REPACKAGES_FAILURE,
    SELECT_INVENTORY_REPACKAGE,
    RESET_CURRENT_INVENTORY_REPACKAGE,
    REQUEST_INVENTORY_REPACKAGE_DETAIL,
    FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS,
    FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE,
    REQUEST_CREATING_INVENTORY_REPACKAGE,
    CREATE_INVENTORY_REPACKAGE_SUCCESS,
    CREATE_INVENTORY_REPACKAGE_FAILURE,
    REQUEST_EDITING_INVENTORY_REPACKAGE,
    EDIT_INVENTORY_REPACKAGE_SUCCESS,
    EDIT_INVENTORY_REPACKAGE_FAILURE
} from './type'

import {
    INVENTORY_REPACKAGES_URL
} from './url';


// InventoryRepackages Actions
import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchInventoryRepackages() {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_REPACKAGES });
        return axios.get(INVENTORY_REPACKAGES_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryRepackagesSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchInventoryRepackagesFailure(err));
            });
    }
}

export function fetchInventoryRepackagesSuccess(inventoryRepackages) {
    return {
        type: FETCH_INVENTORY_REPACKAGES_SUCCESS,
        payload: inventoryRepackages
    };
}

export function fetchInventoryRepackagesFailure(error) {
    return {
        type: FETCH_INVENTORY_REPACKAGES_FAILURE,
        payload: error
    };
}

export function selectInventoryRepackage(inventoryRepackage) {
    return {
        type: SELECT_INVENTORY_REPACKAGE,
        payload: inventoryRepackage
    };
}

export function resetCurrentInventoryRepackage() {
    return {
        type: RESET_CURRENT_INVENTORY_REPACKAGE
    }
}


export function fetchInventoryRepackageDetail(inventoryRepackage_id) {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_REPACKAGE_DETAIL });
        return axios.get(INVENTORY_REPACKAGES_URL + inventoryRepackage_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryRepackageDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchInventoryRepackageDetailFailure(err));
            });
    }
}

export function fetchInventoryRepackageDetailSuccess(inventoryRepackageDetail) {
    inventoryRepackageDetail = inventoryRepackageDetail.data;
    if(inventoryRepackageDetail.PostingDate) inventoryRepackageDetail.PostingDate = convertUtcDate(inventoryRepackageDetail.PostingDate);
    return {
        type: FETCH_INVENTORY_REPACKAGE_DETAIL_SUCCESS,
        payload: inventoryRepackageDetail
    };
}

export function fetchInventoryRepackageDetailFailure(error) {
    return {
        type: FETCH_INVENTORY_REPACKAGE_DETAIL_FAILURE,
        payload: error
    };
}

export function createInventoryRepackage(
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Repackage_Line
) {
  console.log("l", Warehouse_Repackage_Line);
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_INVENTORY_REPACKAGE });
        // if(Warehouse_Repackage_Line) {
        //   Warehouse_Repackage_Line.map(line => {
        //     line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
        //     line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
        //   })
        // }
        axios.post(INVENTORY_REPACKAGES_URL,
            {
              Warehouse_id,
              PostingDate,
              Note,
              Warehouse_Repackage_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createInventoryRepackageSuccess());
              browserHistory.push('/inventories/repackage');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createInventoryRepackageFailure(err));
            });
    }
}

export function createInventoryRepackageSuccess() {
    return {
        type: CREATE_INVENTORY_REPACKAGE_SUCCESS
    }
}

export function createInventoryRepackageFailure(error) {
    return {
        type: CREATE_INVENTORY_REPACKAGE_FAILURE,
        payload: error
    }
}

export function editInventoryRepackage(
  WarehouseRepackage_id,
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Repackage_Line
) {
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    if(Warehouse_Repackage_Line) {
      Warehouse_Repackage_Line.map(line => {
        line['WarehouseBin_id'] = line.WarehouseBin_id.WarehouseBin_id;
        line['WarehouseZone_id'] = line.WarehouseZone_id.WarehouseZone_id;
      })
    }
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_INVENTORY_REPACKAGE });
        axios.put(INVENTORY_REPACKAGES_URL + WarehouseRepackage_id,
            {
              Warehouse_id,
              PostingDate,
              Note,
              Warehouse_Repackage_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editInventoryRepackageSuccess());
              browserHistory.push('/inventories/repackage');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editInventoryRepackageFailure(err));
            });
    }
}

export function editInventoryRepackageSuccess() {
    return {
        type: EDIT_INVENTORY_REPACKAGE_SUCCESS
    }
}

export function editInventoryRepackageFailure(error) {
    return {
        type: EDIT_INVENTORY_REPACKAGE_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/inventoryRepackages_actions.js